// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6aa2a506","453":"5f9bb81d","455":"f0611626","977":"c884d523"}[chunkId] + ".chunk.js";
};